import React from 'react';
import { createRoot } from 'react-dom/client';

import "../i18n";
import IndexApp from './containers/IndexApp';

import '~/scss/pages/index.scss';

createRoot(document.getElementById('index-app')).render(
    <IndexApp
        images = { IMAGES }
        gameSessionStartApiEndpoint = { GAME_SESSION_START_API_ENDPOINT }
        gameSessionFinishApiEndpoint = { GAME_SESSION_FINISH_API_ENDPOINT }
        gameSessionStopApiEndpoint = { GAME_SESSION_STOP_API_ENDPOINT }
    />
);
